module.exports = __webpack_public_path__ + "assets/feature-1.svg";